import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Service from './Pages/Service/Service'
import ContactUs from './Pages/ContactUs/ContactUs'
import AboutUs from './Pages/AboutUs/AboutUs'
import Blog from './Pages/Blog/Blog'
import Blog_Details from './Pages/Blog_Details/Blog_Details'
import OurTeam from './Pages/OurTeam/OurTeam'
import DShieldProMax from './Pages/ServiceDetails/ServiceDetails1'
import Harsafe_Meet from './Pages/HarsafeMeet/Harsafe_Meets'
import Reels_Main from './Pages/Reels/Reels_Main'
import HisabBook from './Pages/HisabBook/HisabBook'
import DShieldPro from './Pages/DShieldPro/DShieldPro_ServiceDetails1'
import SchoolMS from './Pages/SchoolMS/SchoolMS'
import TermsAndCondition from './Pages/otherpage/term-condition/term-condition'
import PrivacyPolicy from './Pages/otherpage/privacy-policy/privacy-policy'
import Android_Enterprise from './Pages/Android_Enterprise/Android_Enterprise'
import Deployment_Management from './Pages/Mobile_Device_Management/Deployment_Management'
import Enterprise_Finance from './Pages/Enterprise_Finance/Enterprise_Finance'
import Compute_Mobility from './Pages/Compute_Mobility/Compute_Mobility'
import Zero_touch_section from './Pages/zero-touch/Zero_touch_section';
import Refund_Policy from './Pages/otherpage/refund-policy/Refund_Policy';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />, 
  },
  {
    path: "Service",
    element: <Service/>,
  },
  {
    path: "ContactUs",
    element: <ContactUs/>,
  },
  {
    path: "AboutUs",
    element: <AboutUs/>,
  },
  {
    path: "Blog",
    element: <Blog/>,
  },
  {
    path: "Blog_Details",
    element: <Blog_Details/>,
  },
  {
    path: "OurTeam",
    element: <OurTeam/>,
  },
  {
    path: "DShieldProMax",
    element: <DShieldProMax/>,
  },
  {
    path: "DShieldPro",
    element: <DShieldPro/>,
  },
  {
    path: "Harsafe_Meet",
    element: <Harsafe_Meet/>,
  },
  {
    path: "Harsafe_Meet_Reels",
    element: <Reels_Main/>,
  },
  {
    path: "Reels_Main",
    element: <Reels_Main/>,
  },
  {
    path: "HisabBook",
    element: <HisabBook/>,
  },
  {
    path: "SchoolMS",
    element: <SchoolMS/>,
  },
  {
    path: "TermsAndCondition",
    element: <TermsAndCondition/>,
  },
  {
    path: "PrivacyPolicy",
    element: <PrivacyPolicy/>,
  },
  {
    path: "Android_Enterprise",
    element: <Android_Enterprise/>,
  },
  {
    path: "Deployment_Management",
    element: <Deployment_Management/>,
  },
  {
    path: "Enterprise_Finance",
    element: <Enterprise_Finance/>,
  },
  {
    path: "Compute_Mobility",
    element: <Compute_Mobility/>,
  },
  {
    path: "Zero_touch_section",
    element: <Zero_touch_section/>,
  },
  {
    path: "Refund_Policy",
    element: <Refund_Policy/>,
  },
]);



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <RouterProvider router={router} />



  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
